import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Accordion } from '@mui/material';
import { styled } from '@mui/material';

import { COLORS } from '~/styles/colors';

// Define the custom props interface
interface StyledAccordionProps {
  $isChild?: boolean;
  $isMedium?: boolean;
  $isNoBg?: boolean;
  $isDraggableItem?: boolean;
  $hideBottomBorder?: boolean;
}

// Accordion styling
export const StyledAccordion = styled(Accordion, {
  shouldForwardProp: (prop) =>
    !['$isChild', '$isMedium', '$isNoBg', '$isDraggableItem', '$hideBottomBorder'].includes(prop as string),
})<StyledAccordionProps>(({ $isChild, $isMedium, $isNoBg, $isDraggableItem, $hideBottomBorder }) => {
  let padding = '10px 12px';
  let baseButtonPadding;
  let detailsPadding;
  let backgroundColor;
  let boxShadow = '0 0 20px 0 rgba(0, 0, 0, 0.05)';
  const isBottomBorder = $isChild && !$hideBottomBorder;

  if ($isChild || $isNoBg) {
    padding = '0';
    baseButtonPadding = 0;
    detailsPadding = 0;
    backgroundColor = COLORS.transparent;
    boxShadow = 'none';
  } else if ($isMedium || $isDraggableItem) {
    padding = '16px';
    baseButtonPadding = 0;
    detailsPadding = 0;

    if ($isDraggableItem) {
      backgroundColor = COLORS.lightGray;
      boxShadow = 'none';
    }
  }

  return {
    borderRadius: isBottomBorder ? '0' : '20px !important',
    boxShadow,
    padding,
    margin: '9px 0',
    backgroundColor,
    border: $isDraggableItem ? `1px solid ${COLORS.grey200}` : undefined,
    borderBottom: isBottomBorder ? `1px solid ${COLORS.grey200}` : undefined,
    '&:before': {
      content: 'unset',
    },
    '&.Mui-expanded': {
      margin: isBottomBorder ? '6px 0 12px' : '6px 0',
      paddingBottom: isBottomBorder ? '20px !important' : undefined,
    },
    '.MuiButtonBase-root': {
      padding: baseButtonPadding,
    },
    '.MuiAccordionDetails-root': {
      padding: detailsPadding,
    },
    '.MuiAccordionSummary-root.Mui-expanded .MuiAccordionSummary-content [data-testid="ArrowDropDownIcon"]': {
      rotate: $isChild ? '180deg' : undefined,
    },
    '.MuiAccordionSummary-content:not(.Mui-expanded)': {
      margin: $isMedium || $isNoBg || $isDraggableItem ? 0 : undefined,
    },
    '.MuiAccordionSummary-content.Mui-expanded': {
      marginTop: $isMedium || $isNoBg || $isDraggableItem ? 0 : undefined,
      marginBottom: $isNoBg ? 0 : 0,
    },
    '.MuiAccordionSummary-root': {
      minHeight: $isMedium || $isNoBg || $isDraggableItem ? 'unset' : undefined,
      '&.Mui-expanded': {
        marginBottom: '20px',
      },
    },
  };
});

// Arrow Icon styling
export const StyledArrowDropDownIcon = styled(ArrowDropDownIcon)(() => ({
  verticalAlign: 'bottom',
  marginRight: '4px',
}));

// Child Summary Container
export const StyledChildSummaryContainer = styled('div')(() => ({
  display: 'flex',
  gap: '10px',
  width: '100%',
}));
